import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// 장바구니에 들어갈 재료 정보
export interface CartItem {
	materialCode: number;
	materialPrice: number;
	quantity: number;
}

// 장바구니 상태
interface CartState {
	cart: CartItem[];
	totalQuantity: number;
	totalPrice: number;
	increaseQuantity: (item: Omit<CartItem, 'quantity'>) => void;
	decreaseQuantity: (materialCode: number) => void;
	clearCart: () => void;
}

export const useCartStore = create<CartState>()(
	persist(
		(set, get) => ({
			cart: [],
			totalQuantity: 0,
			totalPrice: 0,

			// 장바구니에 재료 추가
			increaseQuantity: (item) =>
				set((state) => {
					// 장바구니에 이미 있는 재료인지 확인
					const existingItem = state.cart.find((c) => c.materialCode === item.materialCode);
					// 있으면 개수 증가
					if (existingItem) {
						return {
							cart: state.cart.map((c) => (c.materialCode === item.materialCode ? { ...c, quantity: c.quantity + 1 } : c)),
							totalQuantity: state.totalQuantity + 1,
							totalPrice: state.totalPrice + existingItem.materialPrice,
						};
					}
					// 없으면 장바구니에 추가
					return {
						cart: [...state.cart, { ...item, quantity: 1 }],
						totalQuantity: state.totalQuantity + 1,
						totalPrice: state.totalPrice + item.materialPrice,
					};
				}),

			// 장바구니에 재료 개수 감소
			decreaseQuantity: (materialCode) =>
				set((state) => {
					const existingItem = state.cart.find((c) => c.materialCode === materialCode);
					if (!existingItem || existingItem.quantity <= 0) return state;

					const newQuantity = existingItem.quantity - 1;
					// 개수가 0이하면 장바구니에서 제거
					const cart =
						newQuantity <= 0 ? state.cart.filter((c) => c.materialCode !== materialCode) : state.cart.map((c) => (c.materialCode === materialCode ? { ...c, quantity: newQuantity } : c));

					return {
						cart,
						totalQuantity: state.totalQuantity - 1,
						totalPrice: state.totalPrice - existingItem.materialPrice,
					};
				}),

			// 장바구니 초기화
			clearCart: () => set({ cart: [], totalQuantity: 0, totalPrice: 0 }),
		}),
		// localStorage에 저장
		{ name: 'material-cart' }
	)
);
